<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterCompany' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasCompanies">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="company in companies"
              :key="company.id"
            >
              <CardCompany :company="company" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardCompany from "@/views/Company/components/CardCompany";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      companies: "Company/companies",
    }),
    hasCompanies() {
      return (
        this.companies &&
        Array.isArray(this.companies) &&
        this.companies.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardCompany,
  },
  methods: {
    ...mapActions("Company", ["consultCompanies"]),
  },
  mounted() {
    this.consultCompanies();
  },
};
</script>
